import { stringify } from 'query-string';

import { WapiService } from 'wanderu-service-wapi';

const DEFAULT_DISTANCE = 160934;

export async function getStations({ wCityId, lat, lng }) {
    let qs = {};

    if (wCityId) {
        qs = {
            wcityid: wCityId,
        };
    }

    if (lat && lng) {
        qs = {
            lat,
            lng,
            dist: DEFAULT_DISTANCE,
        };
    }

    return WapiService.get(`stations.json?${stringify(qs)}`);
}

export default {
    getStations,
};
